// Route `api` cho thực thể `crmCustomer` (E-07): JSON của `/v1/customers` (CUSDATA, cột an toàn, không tiền) → `Customer` của màn.
// E-07b: đã khai vào `module.ts` (`api`). Cột worker CHƯA trả (số job, hạn mức / công nợ, myHANA, hợp đồng, hạng, liên hệ…) lấy từ dữ liệu mẫu
// CÙNG ShortName (SAVITA, GREENBUD…); khách thật không có bản mẫu thì mặc định trung tính. Khi worker trả thêm cột thì thay dần ở đây.
import type { ApiRoute } from '@hana/data';
import { CUSTOMERS } from './fixtures';
import type { Customer } from './types';

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

const SAMPLE = new Map(CUSTOMERS.map((c) => [c.id.toUpperCase(), c]));
const NEUTRAL: Customer = {
  id: '', mst: '', kind: 'Tổ chức', sale: '', split: '', bkg: '', bkg2: '', jobs: 0, credit: { limit: 0, used: 0, overdue: 0 }, my: 'no', status: 'ap', contract: 'none', updated: '', updatedBy: '', province: '', region: 'Nội địa', country: 'Việt Nam', tier: 3, segment: 'BCO', contactCount: 0, bankCount: 0,
};

export function customerFromApi(r: Row): Customer {
  const country = str(r.Country);
  const domestic = !country || /^(vn|vietnam|việt nam)$/i.test(country);
  const sale = str(r.SaleName);
  const id = str(r.ShortName);
  const sample = SAMPLE.get(id.toUpperCase());
  return {
    ...(sample ?? NEUTRAL),
    id,
    mst: str(r.Taxcode) || sample?.mst || '',
    sale: sale || sample?.sale || '',
    bkg: str(r.PIC) || sample?.bkg || '',
    province: str(r.Province) || sample?.province || '',
    region: domestic ? 'Nội địa' : 'Nước ngoài',
    country: country || 'Việt Nam',
  };
}

const items = (json: unknown): Row[] => {
  const list = (json as { items?: unknown } | null)?.items;
  return Array.isArray(list) ? (list as Row[]) : [];
};

export const customerApiRoute: ApiRoute<Customer> = {
  path: '/api/v1/customers',
  query: (q) => {
    const limit = q.limit && q.limit > 0 ? q.limit : 50;
    return { q: q.q?.trim(), limit, page: Math.floor((q.offset ?? 0) / limit) + 1 };
  },
  parse: (json) => ({ items: items(json).filter((r) => r.Customer !== false).map(customerFromApi), hasMore: (json as { hasMore?: boolean } | null)?.hasMore === true }),
  parseOne: (json) => (json && typeof json === 'object' && 'ShortName' in json ? customerFromApi(json as Row) : null),
};
